import React, { Component } from 'react'
import { RelationshipProofComponent } from '../components'

class RelationshipProof extends Component {
    
    render() {
        return (
            <RelationshipProofComponent />
        )
    }
}

export default RelationshipProof
